/**
 * PRG-003 — "How it Works" section
 * Desktop (>=990px): Variation 1 — single video, 3-step layout
 * Mobile (<990px): Variation 2 — Swiper carousel with 3 videos per step card
 *
 * Baked from Intelligems A/B test winners (April 2026).
 */
(function () {
    'use strict';

    var isMobile = window.innerWidth < 990;
    var variation = isMobile ? 2 : 1;

    var labels = {
        heroAnchor: 'See how it works',
        title: 'How do Premium Grounding Products Work?',
        description:
            'At Premium Grounding, we specialise in <a href="https://premiumgrounding.com/en-au/collections/premium-grounding-products">grounding sheets</a> designed to reconnect you with the Earth and support your overall well-being. Grounding involves making direct contact with the Earth\'s natural electrical charge to help balance your body\'s own — something modern indoor living disrupts.',
        step1Title: 'Plug it in',
        step1Desc:
            'Connect your grounding sheet or earthing mat to the ground port of your wall outlet, safely connecting you to the Earth without drawing electricity.',
        step2Title: 'Rest, Sleep, Work',
        step2Desc:
            'Place it on your bed (with or without a fitted sheet), desk, or floor. The conductive stainless steel fibres act as an extension to the ground while you rest, sleep or work.',
        step3Title: 'Feel the Difference',
        step3Desc: 'Reduce inflammation, stress, improve sleep, calm the nervous system, and support deeper recovery.',
        ctaLabel: 'SHOP GROUNDING SHEETS & MATS',
        ctaUrl: 'https://premiumgrounding.com/en-au/collections/premium-grounding-products'
    };

    function defer(fn, selector) {
        if (document.querySelector(selector)) {
            fn();
        } else {
            setTimeout(function () {
                defer(fn, selector);
            }, 50);
        }
    }

    function pushEvent(category, details) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'AB_Test_Event',
            AB_Event_Data_1: category,
            AB_Event_Data_2: details,
            AB_Event_Data_Test_ID: 'PRG-003'
        });
    }

    var heroAnchorHtml =
        '<a href="#how-it-works" class="opt-hero-anchor"><div class="opt-hero-anchor-icon"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="40" height="40" rx="20" fill="white"/><path d="M22 14L22 30M22 30L16 24M22 30L28 24" stroke="#3347B4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
        labels.heroAnchor +
        '</a>';

    var howItWorksHtml =
        '<section class="opt-how-it-works" id="how-it-works"><div class="opt-how-it-works-inner"><h2 class="opt-how-it-works-title mobile-only">' +
        labels.title +
        '</h2><div class="opt-how-it-works-video"></div><div class="opt-how-it-works-content"><h2 class="opt-how-it-works-title">' +
        labels.title +
        '</h2><div class="opt-how-it-works-steps"><div class="opt-how-it-works-step"><div class="opt-how-it-works-step-number">1</div><h4 class="opt-how-it-works-step-title">' +
        labels.step1Title +
        '</h4><p class="opt-how-it-works-step-description">' +
        labels.step1Desc +
        '</p></div><div class="opt-how-it-works-step"><div class="opt-how-it-works-step-number">2</div><h4 class="opt-how-it-works-step-title">' +
        labels.step2Title +
        '</h4><p class="opt-how-it-works-step-description">' +
        labels.step2Desc +
        '</p></div><div class="opt-how-it-works-step"><div class="opt-how-it-works-step-number">3</div><h4 class="opt-how-it-works-step-title">' +
        labels.step3Title +
        '</h4><p class="opt-how-it-works-step-description">' +
        labels.step3Desc +
        '</p></div></div><p class="opt-how-it-works-description">' +
        labels.description +
        '</p><a href="' +
        labels.ctaUrl +
        '" class="opt-how-it-works-cta">' +
        labels.ctaLabel +
        '</a></div></div></section>';

    var videoConfigs = [
        {
            thumbnailUrl: 'https://premiumgrounding.com/cdn/shop/files/2_8cdd2e99-d7ce-44bd-925d-bb420f069a0f.png?v=1756967413',
            thumbnailUrlMobile: 'https://cdn.shopify.com/s/files/1/0588/0568/2241/files/ab-test-video-thumbnail-1.png?v=1772420708',
            videoUrl:
                'https://premiumgrounding.com/cdn/shop/videos/c/vp/5bca8c05f5304befa045a86ab6bf637d/5bca8c05f5304befa045a86ab6bf637d.HD-1080p-3.3Mbps-27387676.mp4?v=0'
        },
        {
            thumbnailUrl: 'https://cdn.shopify.com/s/files/1/0588/0568/2241/files/ab-test-video-thumbnail-2.png?v=1772420709',
            videoUrl:
                'https://premiumgrounding.com/cdn/shop/videos/c/vp/61d852b386d944c7ab21f93775005f35/61d852b386d944c7ab21f93775005f35.HD-1080p-3.3Mbps-27387675.mp4?v=0'
        },
        {
            thumbnailUrl: 'https://cdn.shopify.com/s/files/1/0588/0568/2241/files/ab-test-video-thumbnail-3.png?v=1772420708',
            videoUrl:
                'https://premiumgrounding.com/cdn/shop/videos/c/vp/eaf524f48eac4e33a3923318813b50cb/eaf524f48eac4e33a3923318813b50cb.HD-1080p-4.8Mbps-27387674.mp4?v=0'
        }
    ];

    var playSvg = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"></path></svg>';

    function createVideoElement(config, useMobileThumbnail) {
        var wrapper = document.createElement('div');
        wrapper.className = 'opt-video-wrapper';
        var video = document.createElement('video');
        video.setAttribute('poster', useMobileThumbnail && config.thumbnailUrlMobile ? config.thumbnailUrlMobile : config.thumbnailUrl);
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        var source = document.createElement('source');
        source.setAttribute('src', config.videoUrl);
        source.setAttribute('type', 'video/mp4');
        video.appendChild(source);
        var playBtn = document.createElement('div');
        playBtn.className = 'opt-video-social-btn-template';
        playBtn.innerHTML = playSvg;
        wrapper.appendChild(video);
        wrapper.appendChild(playBtn);
        return wrapper;
    }

    function createThumbnailOnlyElement(config, useMobileThumbnail) {
        var wrapper = document.createElement('div');
        wrapper.className = 'opt-video-wrapper opt-thumbnail-only';
        var img = document.createElement('img');
        img.setAttribute('src', useMobileThumbnail && config.thumbnailUrlMobile ? config.thumbnailUrlMobile : config.thumbnailUrl);
        img.setAttribute('alt', '');
        img.loading = 'lazy';
        wrapper.appendChild(img);
        return wrapper;
    }

    var videoPopupPlayBtnHtml =
        '<div class="opt-video-popup-play-btn" aria-hidden="true">' + playSvg + '</div>';
    var videoPopupHtml =
        '<div class="opt-video-popup"><button class="opt-video-popup-close-button"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 17L31 31M17 31L31 17" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></button><div class="opt-video-popup-video">' +
        videoPopupPlayBtnHtml +
        '</div></div><div class="opt-video-popup-backdrop"></div>';

    function handlePlay(videoContainer, video) {
        if (window.innerWidth < 990) {
            document.body.insertAdjacentHTML('beforeend', videoPopupHtml);
            var popup = document.querySelector('.opt-video-popup');
            var popupVideo = document.querySelector('.opt-video-popup-video');
            var popupPlayBtn = document.querySelector('.opt-video-popup-play-btn');
            var closeBtn = document.querySelector('.opt-video-popup-close-button');
            var backdrop = document.querySelector('.opt-video-popup-backdrop');
            var v = video.cloneNode(true);
            popupVideo.appendChild(v);
            v.play();
            pushEvent('User Engagement', 'Play video in popup');

            function updatePlayBtnVisibility() {
                popupPlayBtn.style.display = v.paused ? 'flex' : 'none';
            }
            v.addEventListener('play', updatePlayBtnVisibility);
            v.addEventListener('pause', updatePlayBtnVisibility);
            updatePlayBtnVisibility();

            popupVideo.addEventListener('click', function () {
                if (v.paused) {
                    v.play();
                    pushEvent('User Engagement', 'Play video in popup');
                } else {
                    v.pause();
                    pushEvent('User Engagement', 'Pause video in popup');
                }
            });
            closeBtn.addEventListener('click', function () {
                popup.remove();
                backdrop.remove();
            });
            backdrop.addEventListener('click', function () {
                popup.remove();
                backdrop.remove();
            });
        } else {
            video.play();
            videoContainer.classList.add('opt-how-it-works-video--playing');
            pushEvent('User Engagement', 'Play video');
        }
    }

    function handlePause(videoContainer, video) {
        video.pause();
        videoContainer.classList.remove('opt-how-it-works-video--playing');
        pushEvent('User Engagement', 'Pause video');
    }

    function bindVideoEvents(videoContainer) {
        var video = videoContainer.querySelector('video');
        if (!video) return;
        videoContainer.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (videoContainer.classList.contains('opt-how-it-works-video--playing')) {
                handlePause(videoContainer, video);
            } else {
                handlePlay(videoContainer, video);
            }
        });
    }

    /* ── Mobile V2: Swiper carousel ── */
    /* Self-hosted beside this file in theme assets (no third-party CDN). Falls back to the exact pinned version if this script's own tag cannot be found. */
    var selfTag = document.querySelector('script[src*="prg-003-how-it-works"]');
    var assetBase = selfTag ? selfTag.src.split('?')[0].replace(/[^/]+$/, '') : 'https://cdn.jsdelivr.net/npm/swiper@12.2.0/';
    var SWIPER_CSS = assetBase + (selfTag ? 'vendor-swiper-12.2.0-swiper-bundle.min.css' : 'swiper-bundle.min.css');
    var SWIPER_JS = assetBase + (selfTag ? 'vendor-swiper-12.2.0-swiper-bundle.min.js' : 'swiper-bundle.min.js');

    function loadSwiper(callback) {
        if (window.Swiper) {
            callback();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        document.head.appendChild(link);
        var script = document.createElement('script');
        script.src = SWIPER_JS;
        script.onload = callback;
        document.head.appendChild(script);
    }

    function initMobileCarousel(desktopStepsContainer, configs) {
        var mobileSwiper =
            '<div class="opt-how-it-works-mobile-steps swiper"><div class="swiper-wrapper"></div><div class="swiper-pagination"></div></div>';
        desktopStepsContainer.insertAdjacentHTML('afterend', mobileSwiper);

        var wrapper = document.querySelector('.opt-how-it-works-mobile-steps .swiper-wrapper');
        var cards = document.querySelectorAll('.opt-how-it-works-step');

        cards.forEach(function (card, index) {
            var cloned = card.cloneNode(true);
            cloned.classList.add('swiper-slide');

            var stepVideo = document.createElement('div');
            stepVideo.className = 'opt-how-it-works-step-video';
            var config = configs[index] || configs[0];
            if (index === 0) {
                stepVideo.appendChild(createVideoElement(config, true));
                cloned.insertBefore(stepVideo, cloned.firstChild);
                cloned.insertAdjacentHTML('beforeend', '<button class="opt-how-it-works-step-video-play">Watch video</button>');
                var playBtn = cloned.querySelector('.opt-how-it-works-step-video-play');
                if (playBtn) {
                    playBtn.addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        var sv = cloned.querySelector('.opt-how-it-works-step-video');
                        if (sv) sv.click();
                    });
                }
                bindVideoEvents(stepVideo);
            } else {
                stepVideo.appendChild(createThumbnailOnlyElement(config, true));
                cloned.insertBefore(stepVideo, cloned.firstChild);
            }

            wrapper.appendChild(cloned);
        });

        loadSwiper(function () {
            var SwiperLib = window.Swiper;
            var Pagination = SwiperLib.Pagination || (SwiperLib.modules && SwiperLib.modules.Pagination);
            new SwiperLib('.opt-how-it-works-mobile-steps', {
                modules: Pagination ? [Pagination] : [],
                slidesPerView: 'auto',
                spaceBetween: 4,
                pagination: {
                    el: '.opt-how-it-works-mobile-steps .swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function (swiper) {
                        pushEvent('User Engagement', 'Slide change ' + (swiper.realIndex + 1));
                    },
                    reachEnd: function () {
                        pushEvent('User Engagement', 'View last slide');
                    }
                }
            });
        });
    }

    function setupHowItWorksObserver() {
        var howItWorksElement = document.getElementById('how-it-works');
        if (!howItWorksElement) return;

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        pushEvent('User Engagement', 'Scroll to How it works section');
                    }
                });
            },
            { threshold: 0.3 }
        );

        observer.observe(howItWorksElement);
    }

    function run() {
        try {
            var testClass = 'opt-prg-003';
            var variationClass = 'opt-prg-003-v' + variation;
            if (document.body.classList.contains(testClass) || document.body.classList.contains(variationClass)) return;
            document.body.classList.add(testClass, variationClass);

            // Hide the original "How it Works" section
            defer(function () {
                document.querySelectorAll('h2').forEach(function (h2) {
                    var text = h2.textContent.trim().toLowerCase();
                    if (text.indexOf('how do premium grounding products work') !== -1) {
                        var section = h2.closest('section');
                        if (section) section.classList.add('opt-how-it-works-section-control');
                    }
                });
            }, 'h2');

            // Hero anchor
            defer(function () {
                var target = document.querySelector('div[class*="hero-review-body-template"]');
                if (target) {
                    target.insertAdjacentHTML('afterend', heroAnchorHtml);
                    var heroAnchor = document.querySelector('.opt-hero-anchor');
                    heroAnchor.addEventListener('click', function () {
                        pushEvent('User Engagement', 'Click hero how it works anchor');
                    });
                }
            }, 'div[class*="hero-review-body-template"]');

            // How it works section
            defer(function () {
                var target = document.querySelector('div[id*="__ss_image_with_text"]');
                if (!target) return;
                target.insertAdjacentHTML('afterend', howItWorksHtml);
                target.classList.add('opt-do-you-suffer-from');

                var section = document.querySelector('.opt-how-it-works');
                var videoEl = section && section.querySelector('.opt-how-it-works-video');
                if (videoEl) {
                    videoEl.appendChild(createVideoElement(videoConfigs[0], false));
                    bindVideoEvents(videoEl);
                }

                var featured = document.querySelector('section[id*="__featured_collection"]');
                if (section && featured) section.after(featured);

                // Mobile V2: Swiper carousel with 3 videos
                if (isMobile) {
                    var desktopSteps = document.querySelector('.opt-how-it-works-steps');
                    if (desktopSteps) {
                        initMobileCarousel(desktopSteps, videoConfigs);
                    }
                }

                setupHowItWorksObserver();
            }, 'div[id*="__ss_image_with_text"]');

            pushEvent('User Engagement', 'Session Capture');
            pushEvent('User Engagement', 'Variation ' + variation);
        } catch (e) {
            console.error('PRG-003 failed:', e);
        }
    }

    defer(run, 'body');
})();
